<script>
export const group = 'TopLeft'
</script>

<script setup>
const gsapTimeline = useGsapTimeline()
const props = defineProps({
  item: Object,
})

const programElement = ref(null)
const programElementChildren = ref(null)

const doAppear = async () =>
  gsapTimeline({ name: 'CurrentProgram Appear' })
    .set(programElementChildren, { visibility: 'hidden' })
    .fromTo(shuffle(programElementChildren), { scale: 0.3, transformOrigin: 'bottom center' }, { scale: 1, visibility: 'visible', duration: 0.08, stagger: { amount: 0.24 }, ease: 'power1.Out' })

const doDisappear = async () =>
  gsapTimeline({ name: 'CurrentProgram Disappear' })
    .to(programElement, { letterSpacing: '-6px', duration: 0.125, ease: 'power3.In' })
    .to(shuffle(programElementChildren), { letterSpacing: 0, scale: 0.3, visibility: 'hidden', duration: 0.08, stagger: { amount: 0.12 }, ease: 'power1.Out' }, '<.04')

const program = computed(() => props.item.enrichment.program)
const currentText = ref(program.value.title)

onMounted(doAppear)
watch(
  program,
  async (newProgram) => {
    if (newProgram.title === currentText.value) return

    await doDisappear()
    currentText.value = newProgram.title
    await nextTick(doAppear)
  },
  { deep: true }
)

const { onDisappear } = useDisappearable()
onDisappear(doDisappear)
</script>

<template>
  <SplitCharacters :key="currentText" :text="currentText" class="text-q-cr-red-primary text-[40px] font-semibold" @container="programElement = $event" @children="programElementChildren = $event" />
</template>
